module.exports = __webpack_public_path__ + "img/climate_actions_partner.a7f9b3d.svg";